export default __webpack_public_path__ + "static/media/1stuckinmyways.59288abc.mp3";